import { Box, Button, Chip, Typography } from "@mui/material";
import moment from "moment";
import { setPayoutPage } from "slices/dashboardReducer";
import { useAppDispatch, useAppSelector } from "store/appHooks";
import { convertPrice } from "utils/currency.util";

const PayoutHistory = () => {
  const { dashboardReducer } = useAppSelector((state) => state);
  const { payoutHistory, payoutMeta, payoutPage }: any = dashboardReducer;
  const dispatch = useAppDispatch();

  return (
    <Box>
      <Box
        sx={{
          boxShadow: "0px 3px 6px 0px #25334B1A, 0px 10px 20px 0px #25334B1A",
          borderRadius: "10px",
          background: "#FBFFF3",
        }}
      >
        <Box sx={{ borderBottom: "1px solid #E2E2E2", px: "15px", py: "20px" }}>
          <Typography
            sx={{
              color: "#323232",
              fontSize: "18px",
              fontWeight: 600,
              lineHeight: "26px",
            }}
          >
            Payout History
          </Typography>
        </Box>
        <Box sx={{ px: "15px", py: "20px" }}>
          {payoutHistory.length === 0 && (
            <Box sx={{ my: "20px" }}>
              <Typography>No payments made yet.</Typography>
            </Box>
          )}
          {payoutHistory.map((item: any) => (
            <Box
              sx={{ borderBottom: "1px solid #E2E2E2", pb: "10px", pt: "10px" }}
            >
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <Box>
                  <Typography
                    sx={{
                      color: "#323232",
                      fontWeight: 600,
                      fontSize: "18px",
                      lineHeight: "24px",
                    }}
                  >
                    {item?.user_name}
                  </Typography>
                  <Typography
                    sx={{
                      color: "#323232",
                      fontWeight: 400,
                      fontSize: "15px",
                      lineHeight: "22px",
                      my: "5px",
                    }}
                  >
                    Payment ID - {item?.transaction_id.slice(0, 10)}...
                  </Typography>
                </Box>
                <Box>
                  <Typography
                    sx={{
                      color: "#4EA643",
                      fontWeight: 600,
                      fontSize: "18px",
                      lineHeight: "28px",
                    }}
                  >
                    {convertPrice(item?.payment)}
                  </Typography>

                  <Chip
                    label="Completed"
                    sx={{
                      background: "#EFFFED",
                      color: "#4EA643",
                      fontWeight: 500,
                      fontSize: "13px",
                      lineHeight: "15px",
                    }}
                  />
                </Box>
              </Box>
              <Typography
                sx={{ color: "#A2A2A2", fontSize: "14px", fontWeight: 400 }}
              >
                {moment(item?.transaction_date).format("MMM DD, yyyy hh:mm a")}
              </Typography>
            </Box>
          ))}
        </Box>
      </Box>
      {payoutMeta?.total !== payoutHistory?.length && (
        <Box sx={{ display: "flex", justifyContent: "center", my: "30px" }}>
          <Button
            variant="outlined"
            size="large"
            sx={{ borderRadius: "10px", background: "#FFF" }}
            onClick={() => dispatch(setPayoutPage(payoutPage + 1))}
          >
            Load More Payouts
          </Button>
        </Box>
      )}
    </Box>
  );
};

export default PayoutHistory;
